export default {
    data() {
        return {
            active: 0,
            ultimoFin: null
        }
    },
    computed: {
        totalLiquidacion() {
            let valorTotal = 0

            for (let i = 0; i < this.dataForm.afiliado_liquidacion.liquidacion_devengados.length; i++) {
                valorTotal = valorTotal + Math.round(this.dataForm.afiliado_liquidacion.liquidacion_devengados[i].valor)
            }
            for (let i = 0; i < this.dataForm.afiliado_liquidacion.liquidacion_deducidos.length; i++) {
                valorTotal = valorTotal - Math.round(this.dataForm.afiliado_liquidacion.liquidacion_deducidos[i].valor)
            }

            this.updateDataForm({ state: 'info_liquidacion/valor', data: valorTotal })

            return valorTotal
        }
    },
    created() {
        this.onInit()
    },
    destroyed() {
        this.limpiarAfiliado()
    },
    methods: {
        async onInit() {
            this.searchSw.value = ''
            await this.resetDataForm()
            const await1 = this.updateDataForm({ state: 'info_liquidacion/transporte', data: 102854 })
            const await2 = this.updateDataForm({ state: 'info_liquidacion/fecha', data: this.fecha().fecha.minHoy })
            await await1
            await await2
        }
    }
}